import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import {
  CAvatar,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CModal,
  CCardHeader,
  CModalBody,
  CModalHeader,
  CRow,
  CSpinner,
  CModalTitle,
  CModalFooter,
  CContainer,
  CCol,
} from '@coreui/react'

import { logout, getMsalInstance, getAuthToken } from 'src/common/authentication'
import Splash from 'src/views/pages/login/Splash'


/**
 * Valid Auth States are LOADING, SHOWACK, AUTHING, and AUTHENTICATED.  authState will be used as a primitive state machine
 */

const APIAuthProvider = ({children}) => {
  const [errorMsg, setErrorMsg] = useState(null);
  const [authState,setAuthState] = useState('LOADING')
  const [isAnimatingLeave, setIsAnimatingLeave] = useState(false);

  useEffect(() => {
    const isLoggedIn = checkAuth();
    const isAuthing = sessionStorage.getItem("b2c_redirect") != null;
    sessionStorage.removeItem('b2c_redirect');
    if (!(isLoggedIn || isAuthing)){
      setAuthState('SHOWACK');
    } else if (isAuthing && !isLoggedIn){
      setAuthState('AUTHING');
      waitForLogin(200,150);
    } else if (isLoggedIn){
      setAuthState('AUTHENTICATED');
    }
  }, []);
  //Check if need to acknowledge
  useEffect(()=>{
    console.log(sessionStorage.getItem('acknowledged'));

  },[])

  const checkAuth = () => {
    return !!getAuthToken();
  }

  const waitForLogin = (delay, attempts) => {
    //giving auth time to complete
    attempts = attempts || 50;

    //this should never fail
    let tmpId = setInterval(() => {
      if (checkAuth()) {
        clearInterval(tmpId);
        setAuthState('AUTHENTICATED');
        return;
      }
      if (attempts <= 0) {
        clearInterval(tmpId);
        setAuthState('SHOWACK');
      }
      attempts--;
    }, delay);
  }



  const acknowledgmentOK = () => {
    // Start leave animation on splash screen
    sessionStorage.setItem('acknowledged','true');
    setIsAnimatingLeave(true);
    // setIsAuthenticated(true);
    setTimeout(() => {
      setIsAnimatingLeave(false);
    }, 1125);

  }

  const declineAndExit = () => {
    // logout();
    // getMsalInstance().logoutRedirect();
  }

  const processAckResponse = (accepted) => {
    if (accepted) {
      acknowledgmentOK();
    } else {
      declineAndExit();
    }
  }

  return (
    <>
      {(authState === "AUTHENTICATED") && children}
      {(!(authState === "AUTHENTICATED") || isAnimatingLeave) &&
        <div className={'splash-wrapper' + (isAnimatingLeave ? " animate-leave" : "")}>
          <Splash error={errorMsg} ackResponse={processAckResponse} authState={authState}/>
        </div>
      }
    </>
  )
}

APIAuthProvider.propTypes = {
  children: PropTypes.any,
}

export default APIAuthProvider;